import Vue from 'vue'
import App from './App.vue'
// import './utils/flexible';
import router from "./routes";
import Es6Promise from 'es6-promise';
import 'mint-ui/lib/style.css'
Es6Promise.polyfill()

router.afterEach((to, from) => {
  setTimeout(() => {
    window.scrollTo(0, 0)
    document.documentElement.scrollTo(0, 0)
  }, 0)
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
